import { Component, input, viewChild } from '@angular/core';
import { RidAudioButton } from '../rid-audio-button/rid-audio-button';
import { RidAudioCard } from '../rid-audio-card/rid-audio-card';
import { RidContentCard } from '../rid-content-card/rid-content-card';
import { RidLabeledCard } from '../rid-labeled-card/rid-labeled-card';
import { RidRuleCard } from '../rid-rule-card/rid-rule-card';

export type TOption =
  | { type: 'WORD'; word: string }
  | { type: 'AUDIO'; src: string; size?: 'SMALL' | 'LARGE' }
  | { type: 'SENTENCE'; sentence: string }
  | { type: 'RULE'; rule: string }
  | { type: 'CONTENT'; text?: string; audio?: string; image?: string; layout?: 'VERTICAL' | 'HORIZONTAL' };

@Component({
  selector: 'rid-option',
  imports: [RidLabeledCard, RidAudioCard, RidContentCard, RidRuleCard, RidAudioButton],
  templateUrl: './rid-option.html',
})
export class RidOption {
  option = input.required<TOption>();
  appearance = input<'DEFAULT' | 'INCORRECT' | 'CORRECT'>('DEFAULT');
  index = input<number>();

  audioCard = viewChild<RidAudioCard | RidAudioButton>('audioCard');
  contentCard = viewChild<RidContentCard>('contentCard');

  async present() {
    await Promise.all([
      this.audioCard()?.play(), //
      this.contentCard()?.present(),
    ]);
  }
}
